import React from "react";
import { useNavigate } from "react-router-dom";
import { Wrench } from "lucide-react";
import { fmtMoney, SectionCard } from "./dashUtils";

const STATE_STYLES = {
  available: "bg-emerald-500/10 text-emerald-600",
  on_job: "bg-amber-500/10 text-amber-600",
  inactive: "bg-gray-500/10 text-gray-500",
};
const STATE_LABELS = { available: "Available", on_job: "On Job", inactive: "Inactive" };

const TechnicianOverview = ({ technicians, financialAccess }) => {
  const navigate = useNavigate();
  const summary = technicians?.summary || {};
  const list = technicians?.list || [];
  return (
    <SectionCard title="Technicians" icon={Wrench} testid="technician-overview"
      action={
        <div className="flex items-center gap-1.5">
          <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-emerald-500/10 text-emerald-600 font-medium" data-testid="tech-avail-count">{summary.available || 0} available</span>
          <span className="text-[10px] px-1.5 py-0.5 rounded-full bg-amber-500/10 text-amber-600 font-medium" data-testid="tech-onjob-count">{summary.on_job || 0} on job</span>
        </div>
      }>
      {list.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-5">No technicians configured</p>
      ) : (
        <div className="space-y-1 max-h-[300px] overflow-y-auto pr-1">
          {list.map((t) => (
            <button key={t.technician_id} onClick={() => navigate("/dashboard/technicians")}
              className="w-full flex items-center gap-2.5 rounded-lg px-2 py-1.5 hover:bg-muted/50 transition-colors text-left" data-testid={`tech-row-${t.technician_id}`}>
              <span className="w-7 h-7 rounded-full bg-blue-500/10 text-blue-600 flex items-center justify-center text-[11px] font-bold shrink-0">
                {(t.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("").toUpperCase()}
              </span>
              <span className="min-w-0 flex-1">
                <span className="text-xs font-medium text-foreground block truncate">{t.name}</span>
                <span className="text-[10px] text-muted-foreground">
                  {t.jobs_today > 0 ? `${t.jobs_today} job${t.jobs_today > 1 ? "s" : ""} today · ` : ""}{t.completed} completed
                </span>
              </span>
              {financialAccess && (t.commission || 0) > 0 && (
                <span className="text-[11px] font-semibold text-purple-500 shrink-0">{fmtMoney(t.commission)}</span>
              )}
              <span className={`text-[9px] px-1.5 py-0.5 rounded-full font-medium shrink-0 ${STATE_STYLES[t.state] || STATE_STYLES.inactive}`}>
                {STATE_LABELS[t.state] || t.state}
              </span>
            </button>
          ))}
        </div>
      )}
    </SectionCard>
  );
};

export default TechnicianOverview;
